var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-small t-red leading-tight t-italic",class:{ 'is-active': _vm.isActive && _vm.show },domProps:{"textContent":_vm._s(_vm.error)}})}
var staticRenderFns = []

export { render, staticRenderFns }